"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreGame = void 0;
const support_1 = require("../support");
const ChunkedPosition_1 = require("./ChunkedPosition");
const World_1 = require("./World");
const ChunkListenerService_1 = require("./ChunkListenerService");
const tracingHelper_1 = require("../support/tracingHelper");
const ClickUpdate_1 = require("./ClickUpdate");
const ClickListenerService_1 = require("./ClickListenerService");
const TopListenerService_1 = require("./TopListenerService");
let CoreGame = (() => {
    class CoreGame {
        constructor(difficulty, chunkPersistence, tracer, pointTracker) {
            this.tracer = tracer;
            this.pointTracker = pointTracker;
            this.chunkListenerService = new ChunkListenerService_1.ChunkListenerService();
            this.clickListenerService = new ClickListenerService_1.ClickListenerService();
            this.topListListener = new TopListenerService_1.TopListenerService();
            this.updateListeners = new Map();
            this.chunkSize = new support_1.Vector2(64, 32);
            this.world = new World_1.World(this.chunkSize, (update) => this.onChunkUpdate(update), difficulty, chunkPersistence, tracer);
            setInterval(this.sendTopList.bind(this), 1000);
        }
        async on(ctx, type, chunk, callback) {
            switch (type) {
                case "click":
                    return await this.onClick(ctx, type, chunk, callback);
                case "update":
                    return await this.onUpdate(ctx, type, chunk, callback);
            }
        }
        async onTopList(_, callback) {
            return await this.topListListener.register(callback);
        }
        async onUpdate(__, _, chunk, callback) {
            return await this.chunkListenerService.registerListener(chunk, callback);
        }
        async onClick(__, _, chunk, callback) {
            return await this.clickListenerService.registerListener(chunk, callback);
        }
        async removeListener(__, token) {
            this.chunkListenerService.unregisterListener(token);
        }
        async removeClickListener(_, token) {
            this.clickListenerService.unregisterListener(token);
        }
        async removeTopListener(_, token) {
            this.topListListener.remove(token);
        }
        async getTileContents(context, chunk) {
            return await this.world.getChunkTiles(context, chunk);
        }
        async getChunkSize(__) {
            return this.chunkSize;
        }
        async openTile(context, position) {
            console.log('opening tile', position);
            await this.world.openTile(context, position);
            this.sendClickEvent(context, position);
        }
        async flag(context, position) {
            await this.world.flag(context, position);
            this.sendClickEvent(context, position);
        }
        onChunkUpdate(update) {
            this.chunkListenerService.onChunkUpdate(update);
            const listeners = this.updateListeners.get(update.chunk.asMapKey());
            if (listeners !== undefined) {
                listeners.forEach(cb => cb(update));
            }
        }
        sendClickEvent(ctx, position) {
            const user = ctx.getData('user');
            if (!user) {
                return;
            }
            this.clickListenerService.onClick(new ClickUpdate_1.ClickUpdate(position, user.getUsername()));
        }
        sendTopList() {
            const entries = this.pointTracker.getFiveMinuteTop();
            this.topListListener.onTopList(entries);
        }
        getTracer() {
            return this.tracer;
        }
    }
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, String]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "removeListener", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, String]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "removeClickListener", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, String]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "removeTopListener", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, support_1.Vector2]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "getTileContents", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "getChunkSize", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, ChunkedPosition_1.ChunkedPosition]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "openTile", null);
    __decorate([
        tracingHelper_1.traced(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [support_1.Context, ChunkedPosition_1.ChunkedPosition]),
        __metadata("design:returntype", Promise)
    ], CoreGame.prototype, "flag", null);
    return CoreGame;
})();
exports.CoreGame = CoreGame;
//# sourceMappingURL=CoreGame.js.map